import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Box, Card, Typography, Button, Divider, useMediaQuery, Breadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {SectionTitle} from '../components/SectionTitle';
import moment from 'moment';
import CustomMetaData from 'src/hooks/CustomMetaData';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { db } from 'src/config/firebase';
import { Rating } from '@mui/material';
import Carousel from 'react-elastic-carousel';
import { Today, EventAvailable, PeopleAltOutlined, StarBorder, StarBorderRounded, LocalOffer, Twitter, Facebook,WhatsApp,  } from '@mui/icons-material';
import IconWrapper from '../components/IconWrapper';
import ServiceCard from '../components/ServiceCard';
import ImageGallery from 'react-image-gallery';
import { PhotoPreview } from 'src/components/white-label-component/company-comp';
import { useCompanyData } from '../../shared/contexts/DataContext';
import useServiceDetails from '../../shared/logic/useServiceDetails';
import Header from '../components/Header';
import OnlineTag from '../components/OnlineTag';
import imgProfile from '../../../../../assets/images/templates/profile.jpg';
import imgProfile2 from '../../../../../assets/images/templates/profile.png';
import { serviceDetailsImage } from '../../shared/logic/imagesFns';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { createMarkup } from '../../shared/logic/Utils';
import AppointmentBook from '../../shared/components/AppointmentBook/AppointmentBook';
import useRTL from 'src/hooks/useRTL';
import { theme } from '../Template';
import "react-image-gallery/styles/css/image-gallery.css";
import youtubeVideo from '../../../../../assets/images/templates/t4/youtube.png';

const useStyles = makeStyles((theme) => ({

  carousel: {
    position: 'relative',
    '& .rec.re-arrow': {
      position: 'absolute',
      backgroundColor: 'white',
      zIndex: '10',
      top: '38%',
    },

    '& .rec.rec-dot': {
      display: 'none',
    },
    '& .rec.rec-arrow:last-child': {
      right: 0,
    },
    '& .rec.rec-arrow:hover': {
      backgroundColor: '#17C799',
    },
    '& .rec.rec-arrow:disabled': {
      visibility: 'hidden',
    },
  },

  menuTab:{
    fontSize: '1.2rem',
    padding: '25px 0px',
    margin:'0px 16px',
    color:'#16466d',
    cursor:'pointer',
    [theme.breakpoints.between('xs','md')]: {
      padding: '17px 0px',
      fontSize: '1rem',
    }
  },

  activeTab:{
    color:'#17C799',
    borderBottom: '2px solid #17C799',
  },

  iconFilled:{
    color: '#ffbd01 !important',
  },

  iconEmpty:{
    color: '#ffbd01 !important',
  },

  iconHover:{
    color: '#ffbd01',
  },

  icon:{
    display:'unset !important'
  },

  starDiv:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    width:'35px',
    height:'35px',
    borderRadius:'50%',
    border: '1px solid #e3e3e3',
    backgroundColor:'#fff',
    '& svg':{
      color:'#15476d'
    }
  },

  shareDiv:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    width:'35px',
    height:'35px',
    borderRadius:'50%',
    border: '1px solid #e3e3e3',
    backgroundColor:'#fff',
    cursor:'pointer',
    margin:'16px 5px 5px 5px',
    '& svg':{
      color:'#15476d',
      fontSize:'1rem'
    },

    "&:hover":{
      border: '1px solid #17C799',
      backgroundColor:'#17C799'
    },


    "&:hover > $svg": {
      color:'#fff'
    },
  },

  breadWhite:{
    color:'#fff',
    fontSize:'1.3rem'
  },

  galleryClass:{
    '& .image-gallery-content': {
      '& .image-gallery-slide-wrapper': {
          '& .image-gallery-left-nav':{
            display: 'none !important',
          },
          '& .image-gallery-right-nav':{
            display: 'none !important',
          },

          '& .image-gallery-swipe':{
            '& .image-gallery-slides':{
              borderRadius: '20px !important',
              [theme.breakpoints.down('md')]:{
                height: 'unset !important',
                borderRadius: '20px !important',
                width:'100% !important'
              },

              '& .image-gallery-slide':{
                borderRadius: '20px !important',
                height:'auto !important',
                [theme.breakpoints.down('md')]:{
                  height:'auto !important',
                  maxHeight: '300px !important',
                },

                '& .image-gallery-image':{
                  borderRadius: '20px !important',
                  height:'auto !important',
                  maxHeight: '300px !important',
                  [theme.breakpoints.down('md')]:{
                    height:'auto !important',
                    maxHeight: '300px !important',
                  },
                }
              },
            },
          }
      }
    },
  },

  descSpan:{
    '& li':{
      listStyle:'inherit'
    }
  }
}));

const ServiceDetails = () => {
  const [tab, setTabs] = React.useState('overview');
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { service, groups, reviews, t, photos, handleBooking, videoEmbedSrc, schedule } = useServiceDetails();
  const { data } = useCompanyData();
  const { id } = service || {};
  const [, , fontFamily] = useRTL('',"Playfair Display, serif");
  const [, ,  fontFamily2] = useRTL();
  const { relatedProduct,productType, companyDomain,companyData, displayBanner=true } = data || {};
  const tabEvent = tabs => setTabs(tabs);
  const classes = useStyles();

  const [previewDialog, setPreviewDialog] = React.useState(false);
  const [activeImg, setActiveImg] = React.useState('');
  const [_fileType, setFileType] = React.useState('image');

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[id]);

  const previewEvent = (img,fileType) => {
    setPreviewDialog(true);
    setActiveImg(img);
    setFileType(fileType);
  };

  const closeDialog = () => {
    setPreviewDialog(false);
    setActiveImg('');
    setFileType('image');
  };

  return (
    <div>
      <CustomMetaData
        {...{
          title: `${companyData?.name} - ${service?.name}`,
          image: companyData && companyData.avatar,
          description: service?.description
        }}
      />
      <Header
        height="400px"
        title={service?.name}
        image={serviceDetailsImage(service, photos)}
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={displayBanner}
        titleColor="#ffffff"
        data={data}
        position="relative"
        onClickEvent={()=> previewEvent(serviceDetailsImage(service, photos),'image')}
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:'inherit'}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem'}}>{t && t('companyPage.services')}</Typography>
        </Breadcrumbs>
        <OnlineTag
          online={service?.online}
          color='#17C799'
          bgColor='#fff'
        />

      </Header>


      <Box
        display="flex"
        flexDirection={matches ? 'row' : 'column'}
        alignItems="flex-start"
        width={'90%'}
        m="auto"
      >
        <Box width={{ xs: '100%', lg: '70%' }}>
          <MenuButtons matches={matches} t={t} tab={tab} tabEvent={tabEvent} />
          <Overview service={service} tab={tab} reviews={reviews} videos={videoEmbedSrc} data={data} photos={photos} t={t} fontFamily={fontFamily} fontFamily2={fontFamily2} matches={matches} />
          
          {schedule ? <AppointmentWrapper schedule={schedule} serviceId={id} data={data} t={t} fontFamily={fontFamily}/> : null}
          
          {tab === 'overview' && groups?.length ?
           <Groups groups={groups} handleBooking={handleBooking} data={data} t={t} fontFamily={fontFamily} fontFamily2={fontFamily2} matches={matches} />
          : null}
          {tab === 'overview' ?
          reviews.length > 0 ? 
            <Reviews reviews={reviews} t={t} data={data} tabEvent={tabEvent} tab={tab} matches={matches} fontFamily={fontFamily2} fontFamily2={fontFamily2} withCard={true} />
          :
          null
            // <Typography style={{fontFamily}}>{t && t('companyPage.sorryNoReviews')}</Typography>
          : null
          }
        </Box>

        {service?.serviceDeliver ?
        <Box width={{xs: '100%', lg: '30%'}}>
          <MemberInfo memberId={service?.serviceDeliver} t={t} reviews={reviews} fontFamily={fontFamily} fontFamily2={fontFamily2} />
        </Box>
        : null }
      </Box>
      {relatedProduct && productType === 'services' && (
        <Services
          services={data.products || []}
          categories={data.categories || []}
          t={t}
          data={data}
          fontFamily={fontFamily}
        />
      )}

      {previewDialog && activeImg ? <PhotoPreview dataArray={[{path:activeImg,type:_fileType}]} closeEvent={closeDialog} /> : null}

    </div>
  );
};

const Overview = ({ service, reviews, t, fontFamily, matches,photos, videos, fontFamily2, tab, data }) => {
  const classes = useStyles();
  const [showVideo,setShowVideo] = React.useState({});

  const [, , paragraphFontFamily] = useRTL('',"'Roboto', sans-serif");


  const _renderVideo = (item) => {

  const _toggleShowVideo = (url) => {
    setShowVideo({
      ...showVideo,
      [url]: !showVideo[url]
    });
  };

    return (
      <div>
        <div style={{position: 'relative',padding: '33.35% 0',height: 0}}>
            <a
              className='close-video'
              onClick={() => _toggleShowVideo(item.embedUrl)}
            >
            </a>
            <iframe
              width='100%'
              height={matches ? '80%' : '300px'}
              src={item.embedUrl}
              frameBorder='0'
              allowFullScreen
              style={{position:'absolute',top:0,left:0,borderRadius:'20px'}}
            >
            </iframe>
        </div>
      </div>
    );
  };

  let images = [
    {
      original:service?.cover,
      thumbnail:service?.cover,
      loading:"lazy",
      originalAlt:service?.name,
      thumbnailAlt:service?.name
    }
  ];

  if(videos.length > 0) {
    videos.forEach(v => {
      var obj = {
        original:youtubeVideo,
        thumbnail:youtubeVideo,
        embedUrl: v,
        originalAlt:service?.name,
        thumbnailAlt:service?.name,
        renderItem: () => _renderVideo({
          original:youtubeVideo,
          thumbnail:youtubeVideo,
          embedUrl: v,
          originalAlt:service?.name,
          thumbnailAlt:service?.name,})
      };
      images.push(obj)
    })
  };

  if(photos.length > 0) {
    photos.forEach(v => images.push({
      original:v.photoPath,
      thumbnail:v.photoPath,
      loading:"lazy",
      originalAlt:service?.name,
      thumbnailAlt:service?.name
    }))
  };

  return (
    <Box py={5} width={matches ? "90%": '100%'}
    // m="auto"
    >
      <Box display="flex" justifyContent="space-between" overflow="visible">
        <Box width="100%">

          <Card
            style={{
              borderRadius: '20px',
            }}
          >

            <Box py={{ xs: 1, md: 3 }} px={{ xs: 2, md: 4 }}>
              {tab === 'overview' ?
              <>
              <Box pb={3} borderRadius="20px" overflow="hidden">
              <ImageGallery
                items={images}
                showPlayButton={false}
                showFullscreenButton={false}
                additionalClass={classes.galleryClass}
              />
              </Box>
              <Box pb={3}>
                <SectionTitle pFontSize="18" pb={2}>
                  {t && t('companyPage.description')}
                </SectionTitle>
                <Typography variant="body2" style={{fontFamily:'inherit'}} className={classes.descSpan} dangerouslySetInnerHTML={createMarkup(service?.shortDescription)}>
                </Typography>
              </Box>
              </>
              : 
              tab === 'reviews' ?
              reviews.length > 0 ? <Reviews reviews={reviews} t={t} data={data} matches={matches} fontFamily={fontFamily} fontFamily2={fontFamily2} />
              :
              reviews?.length < 1 && (
                <Typography style={{fontFamily:'inherit'}}>{t && t('companyPage.sorryNoReviews')}</Typography>
              )
              : null
              }
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

const Reviews = ({ reviews, t, fontFamily, fontFamily2, data, matches, withCard=false, tab, tabEvent }) => {
  const { setPage, count, currentItems } = useMyPagination(reviews, 3);
  const { buttonColor, buttonFontColor } = data || {};
  const showAll = () => {
    window.scrollTo(0,0);
    tabEvent('reviews')
  }

  return (
    <Box pb={3}  py={withCard ? 5 : ''} width={withCard && matches ? "90%": withCard ? '100%' : 'auto'} >
      <SectionTitle pFontSize="18" pb={2}>
        {t && t('companyPage.reviews')}
      </SectionTitle>
      {withCard ?
      <Card
        style={{
          borderRadius: '20px',
        }}
      >
        <Box py={{ xs: 1, md: 3 }} px={{ xs: 2, md: 4 }}>

        <Box py={2} style={{width:'100%',display:'flex',flexDirection:'column'}}>
            {currentItems?.map((item, i) => (
              <ReviewItem key={i} review={item} data={data} fontFamily2={fontFamily2} />
            ))}
        </Box>
        <MyPagination count={count} onChange={setPage} />
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <Button
            onClick={showAll}
            variant="contained"
            color="primary"
            size="large"
            style={{fontFamily:'inherit',backgroundColor:buttonColor ? buttonColor : 'inherit',color: buttonFontColor ? buttonFontColor : 'inherit'}}
          >
            {t && t('companyPage.exploreServices')}
          </Button>
        </Box>

        </Box>
      </Card>
      :
      <>
        <Box py={2} style={{width:'100%',display:'flex',flexDirection:'column'}}>
            {currentItems?.map((item, i) => (
              <ReviewItem key={i} review={item} data={data} fontFamily2={fontFamily2} />
            ))}
        </Box>
        <MyPagination count={count} onChange={setPage} />
      </>
      }

    </Box>
  );
};

const ReviewItem = ({ review, fontFamily2,data }) => {
  const classes = useStyles();
  const { avatar, name } = data.companyData || {};

  return (
    <>
      <Box
        py={2}
        px={2}
        mb={!review.reply ? 2 : 0}
        display="flex"
        width={!review.reply ? "calc(100% - 32px)" : "calc(100% - 34px)"}
        borderRadius="15px"
        border="1px solid #e3e3e3"
        bgcolor="#fafafa"
        style={review.reply ? {borderBottomRightRadius:'0px'} : {}}
      >
        <Box width="50px" height="50px" mx={2} borderRadius="50%">
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
              src={review.parentAvatar || imgProfile}
              alt={review.parentName || 'profile'}
            />
          </ImgLazyLoad>
        </Box>
        <Box width="90%">
          <Box pb={2} display="flex" justifyContent="space-between">
            <Box>
              <SectionTitle pFontSize="16">{review.parentName || '---'}</SectionTitle>
              <Typography variant="subtitle2" style={{fontFamily:'inherit'}}>{moment(new Date(review.reviewDate*1000)).format('D MMM YYYY')}</Typography>
            </Box>
            <Rating
                classes={{
                  iconHover:classes.iconHover,
                  iconFilled:classes.iconFilled,
                  iconEmpty:classes.iconEmpty,
                  icon:classes.icon
                }}
                name="review-rating"
                value={Number(review.rating)}
                precision={0.1}
                readOnly
                emptyIcon={<StarBorder fontSize="inherit" />}
              />
          </Box>
          <Typography variant="body2" style={{fontFamily:'inherit'}}>{review.comment}</Typography>
        </Box>
      </Box>
      {review.reply ?
      <Box
        py={1}
        px={1}
        mb={2}
        display="flex"
        width="calc(70% - 2px)"
        borderRadius="15px"
        border="1px solid #e3e3e3"
        bgcolor="#fafafa"

        style={{
          alignSelf: 'flex-end',
          borderTopRightRadius: '0px',
          borderTopLeftRadius: '0px',
        }}
      >
        <Box width="50px" height="50px" mx={2} borderRadius="50%">
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
              src={avatar || imgProfile}
              alt={name || 'profile'}
            />
          </ImgLazyLoad>
        </Box>
        <Box width="90%">
          <Box pb={2} display="flex" justifyContent="space-between">
            <Box>
              <SectionTitle pFontSize="16">{name}</SectionTitle>
              <Typography variant="subtitle2" style={{fontFamily:'inherit'}}>{moment(new Date(review.replyDate*1000)).format('D MMM YYYY')}</Typography>
            </Box>
          </Box>
          <Typography variant="body2" style={{fontFamily:'inherit'}}>{review.reply}</Typography>
        </Box>
      </Box>
      : null }
    </>
    
  );
};

const Groups = ({ groups, handleBooking, t, fontFamily, matches, fontFamily2, data }) => {
  const { setPage, count, currentItems } = useMyPagination(groups, 4);
  return (
    <Box py={5} width={matches ? "90%": '100%'} fontFamily={'inherit'}>
      <Box pb={3}>
        <SectionTitle pFontSize="36">{t && t('services.group-section.title')}</SectionTitle>
      </Box>
      <Box width={'100%'}>
        <Card
          style={{
            borderRadius: '20px',
          }}
        >
          <Box py={3} px={matches ? 4 : 2}>
            {currentItems?.map((item, i) => (
              <GroupItem
                key={i}
                group={item}
                matches={matches}
                fontFamily={fontFamily}
                fontFamily2={fontFamily2}
                handleBooking={handleBooking}
                data={data}
                isLast={i === groups.length - 1}
                t={t}
              />
            ))}
            {groups?.length < 1 && (
              <Typography style={{fontFamily:'inherit'}}>{t && t('companyPage.sorryNoGroups')}</Typography>
            )}
          </Box>
          <MyPagination count={count} onChange={setPage} />
        </Card>
      </Box>
    </Box>
  );
};

const AppointmentWrapper = ({ schedule, data, t, fontFamily, serviceId }) => {
  return (
    <Box width="100%" pb={3}>
      <Box pb={3}>
        <SectionTitle pFontSize="36">{t && t('services.group-section.appTitle')}</SectionTitle>
      </Box>
      <AppointmentBook schedule={schedule} serviceId={serviceId} data={data} t={t} fontFamily={fontFamily}/>   
    </Box>
  );
};

const GroupItem = ({ group, handleBooking, isLast, t, fontFamily2, matches,data }) => {
  const currentTime = moment().unix();
  const offer = (group.offer && group.offerValidity > currentTime);
  const { buttonColor, buttonFontColor } = data || {};
  const isConvertCurrency = group?.convertCurrency && group?.displayPrice && group?.displayCurrency;

  return (
    <Box width="100%">
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
        mb={1}
      >
        <SectionTitle
          pFontSize="21"
          whiteSpace="nowrap"
          style={{
            textTransform: 'capitalize',
            width: '70%',
            textOverflow: "ellipsis",
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '70%'
          }}
        >
          {group.name}
        </SectionTitle>
        <Box
          display="flex"
          flexDirection="column" 
          py={{ xs: 1, lg: 0 }}
          width={ matches ? 'auto' : '100%' }
          alignItems={!matches ? 'flex-start' :"center"}
          // justifyContent={!matches ? 'flex-end' : ''}
        >
          <Box
            py={{ xs: 1, lg: 0 }}
            width={{ xs: '100%', lg: 'auto' }}
            display="flex"
            alignItems="center"
          >
            <SectionTitle pFontSize="18">
              {isConvertCurrency ?
              `${group.displayCurrency} ${group.displayPrice}` :
              `${group.currency} ${offer ? group.offerPrice : group.groupPrice}`}
            </SectionTitle>
            {offer && (
              <SectionTitle
                pFontSize="14"
                mx={2}
                style={{ textDecoration: 'line-through', opacity: '0.4' }}
              >
                {group.currency} {group.groupPrice}
              </SectionTitle>
            )}
            { offer ? <LocalOffer style={{color:'#17C799'}}/> : null }
          </Box>
          {isConvertCurrency ?
            <SectionTitle pFontSize="14" fontWeight="normal" style={{paddingBottom:'0px',fontWeight:'normal !important'}}>
              {`Pay ${group?.groupPrice} ${group.currency}`}
            </SectionTitle>
          : null}
        </Box>
      </Box>
      <Box display="flex" flexDirection={matches ? 'row' : 'column'} alignItems="center" justifyContent="space-between">
        <Box maxWidth={{ xs: '100%', md: '85%' }}>
          <GroupInfo {...group} t={t} fontFamily2={fontFamily2} />
        </Box>
        <Button
          onClick={() => handleBooking(group.id)}
          variant="contained"
          color="primary"
          style={{fontFamily:'inherit',alignSelf: matches ? 'unset' : 'flex-end',backgroundColor: buttonColor ? buttonColor : 'primary',color:buttonFontColor ? buttonFontColor : ''}}
        >
          {t && t('companyPage.bookNow')}
        </Button>
      </Box>
      <Box py={2}>{!isLast && <Divider />}</Box>
    </Box>
  );
};

const MenuButtons = ({ t,matches, tab, tabEvent }) => {
  const classes = useStyles();
  const [, , fontFamily] = useRTL();
  return (
    <Box py={5} width={matches ? "90%" : "100%"} fontFamily={'inherit'}>
      <Box width={matches ? "calc(100% - 60px)" : "calc(100% - 30px)"} style={{display:'flex',flexDirection:'row',alignItems:'center', boxShadow:'0 0 30px rgb(209 209 209)',borderRadius:'20px',padding: matches ? '0px 30px' : '0px 15px'}}>
        {[{label:t && t('companyPage.overview'),value:'overview'},{label: t && t('companyPage.reviews'),value:'reviews'}].map(v=>{
          return <span style={{fontFamily:'inherit'}} onClick={()=> tabEvent(v.value)} className={`${classes.menuTab} ${tab === v.value ? classes.activeTab : ''}`}>{v.label}</span>
        })
        }
      </Box>
    </Box>
  );
};

const GroupInfo = ({ startDate, endDate, durationDays, numberDays, availableSeats, subscription, groupType, fontFamily2, t }) => {
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" color="#15476D">
      {/* period */}
      {groupType === 'subscription' ?
      <Box
        display="flex"
        alignItems="center"
        mr={1.5}
        mb={1}
        width={{ xs: '100%', md: 'auto' }}
        maxWidth={{ xs: '100%', md: '200px' }}
        style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
      >
        <IconWrapper mx={1}>
         <Today />
        </IconWrapper>
        <Box fontWeight={700}>
          <Typography style={{ fontWeight: 500,fontSize:'0.9rem', fontFamily:'inherit' }}>{t && t('companyPage.period')}</Typography>
          <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:'inherit',textTransform:'capitalize'}}>
            {`${subscription} ${subscription === 'custom period' ? "("+numberDays+")" : ''}`}
          </Typography>
        </Box>
      </Box>
      : null }
      {/* start date */}
      {groupType === 'course' ?
      <Box
        display="flex"
        alignItems="center"
        mr={1.5}
        mb={1}
        width={{ xs: '80%', md: 'auto' }}
        maxWidth={{ xs: '80%', md: '160px' }}
        style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
      >
        <IconWrapper mx={1}>
          <Today />
        </IconWrapper>
        <div>
          <Typography style={{ fontWeight: 500,fontSize:'0.9rem', fontFamily:'inherit' }}>{t && t('reservation.start-date')}</Typography>
          <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:'inherit'}}>
            {moment(startDate * 1000).format('Do MMM YYYY')}
          </Typography>
        </div>
      </Box>
      : null }

      {/* end date */}
      {groupType === 'course' ?
      <Box
        display="flex"
        alignItems="center"
        mr={1.5}
        mb={1}
        width={{ xs: '80%', md: 'auto' }}
        maxWidth={{ xs: '80%', md: '160px' }}
        style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
      >
        <IconWrapper mx={1}>
          <EventAvailable />
        </IconWrapper>
        <Box fontWeight={700}>
          <Typography style={{ fontWeight: 500,fontSize:'0.9rem', fontFamily:'inherit' }}>{t && t('renew.endDate')}</Typography>
          <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:'inherit'}}>
            {moment(endDate * 1000).format('Do MMM YYYY')}
          </Typography>
        </Box>
      </Box>
      : null }

      <Box
        display="flex"
        alignItems="center"
        mr={1.5}
        mb={1}
        width={{ xs: '80%', md: 'auto' }}
        maxWidth={{ xs: '80%', md: '160px' }}
        style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
      >
        <IconWrapper mx={1}>
          <PeopleAltOutlined />
        </IconWrapper>
        <div>
          <Typography style={{ fontWeight: 500,fontSize:'0.9rem', fontFamily:'inherit' }}>{t && t('group-list.gp-avail')}</Typography>
          <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:'inherit'}}>{availableSeats}</Typography>
        </div>
      </Box>
    </Box>
  );
};

const MemberInfo = ({ reviews, memberId, fontFamily, fontFamily2, t }) => {
  const isMounted = React.useRef(null);
  const [name,setName] = React.useState('');
  const [roleType,setRoleType] = React.useState('');
  const [avatar,setAvatar] = React.useState('');
  const classes = useStyles();
  const path = window.location.href;

  React.useEffect(()=> {
    isMounted.current = true;
    if(memberId && isMounted.current) {
      db.ref(`PartnerTeams/${memberId}`).once('value',(data)=>{
        const memberData = data.val();
        if(memberData) {
          setName(`${memberData.firstName} ${memberData.lastName}`);
          setAvatar(memberData?.avatar || '');
          setRoleType(memberData?.roleType || '');
        }
        else{
          setName('');
          setRoleType('');
          setAvatar('');
        }
      })
    };
    return () => {
      isMounted.current = false;
    }
  },[memberId]);

  const shareEvent = link => {
    window.open(link,'_blank');
  }

  const actions = [
    { icon: <Twitter className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://twitter.com/intent/tweet?url=${path}`) },
    { icon: <Facebook className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://www.facebook.com/sharer/sharer.php?u=${path}`) },
    { icon: <WhatsApp className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://wa.me/?text=${path}`) },
  ];

  return (
    <Box my={5} width={"100%"}  fontFamily={'inherit'} style={{ boxShadow:'0 0 30px rgb(209 209 209)',borderRadius:'20px',}}>
      {/* top section */}
      <Box width={"calc(100% - 30px)"} style={{display:'flex',flexDirection:'row',alignItems:'center',padding:'0px 15px'}}>
        <Box
          py={2}
          display="flex"
          width={"100%"}
        >
          <Box width="90px" height="65px" mx={2} borderRadius="50%" style={{backgroundColor:'#17C799',border:'2px solid #17C799'}}>
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
              src={avatar || imgProfile2}
              alt={name || 'profile'}
            />
          </ImgLazyLoad>
          </Box>
          <Box width="100%">
            <Box pb={2} display="flex" justifyContent="space-between">
              <Box>
                <Typography variant="body-1" fontSize="1.4rem">{name || '---'}</Typography>
                <Typography variant="subtitle2" style={{fontFamily:'inherit',color:'#17C799',fontSize:'1.1rem',lineHeight:2,textTransform:'capitalize'}}>{roleType || '---'}</Typography>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <div className={classes.starDiv}>
                    <StarBorderRounded />
                  </div>
                  <Typography variant="subtitle2" style={{fontFamily:'inherit',fontSize:'1.1rem',lineHeight:2,margin:'0px 8px'}}>{t && t('service.review',{count:reviews.length})}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box style={{padding:'0px 16px'}}>{<Divider />}</Box>
      {/* bottom section */}
      <Box
          display="flex"
          width={"calc(100% - 30px)"}
          style={{padding:'15px 15px',flexDirection:'column'}}
      >
        <SectionTitle pFontSize="21">{t && t('companyPage.memberShare')}</SectionTitle>
        <Box display="flex" flexDirection="row" alignItems="center"> 
          {actions.map(v=> {
            return(
              <div className={classes.shareDiv} onClick={v.clickEvent}>
                {v.icon}
              </div>
            )
          })}
        </Box>
      </Box>
    </Box>
  );
};

const SectionSubtitle = ({ children, ...props }) => {
  return (
    <Box fontSize={{ xs: '1rem', sm: '1.3rem' }} {...props}>
      <Typography
        variant="h6"
        color="textSecondary"
        style={{ fontSize: 'inherit' }}
      >
        {children}
      </Typography>
    </Box>
  );
};


const Services = ({ services, categories, t, data, fontFamily }) => {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const classes = useStyles();
  const { serviceId } = useParams();
  services = services.length > 0 ? services.filter(v => v.id !== serviceId) : [];
  categories = categories.length > 0 ? categories.filter(v => v.id !== serviceId) : [];
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 900, itemsToShow: 2 },
    { width: 1000, itemsToShow: 3 },
  ];

  const displayDescription = data.displayProductDesc !== undefined ? data.displayProductDesc : true;
  const productType = data.productType;
  const companyId = data.companyData ? data.companyData.companyId : '';
  if((productType === 'services' && data.products?.length > 0)) {
    return (
      <Box bgcolor="rgb(242 242 242)" style={{paddingBottom:'100px'}}>
        <Box py={5} width="90%" m="auto">
          <Box pb={3} className={classes.serviceTitleDiv} style={!matches ? {textAlign:'center',display:'unset'} : {}}>
            <Box style={!matches ? {paddingBottom:'24px',textAlign:'center'} : {textAlign:'center'}}>
              <SectionTitle style={data.isRTL === 'ar' ? {paddingBottom:'15px'} : {}}>{productType === 'categories' ? t && t('companyPage.relatedCategory') : t && t('companyPage.relatedService')}</SectionTitle>
            </Box>
          </Box>
          
          {matches ? (
            <Box>
              <Carousel className={classes.carousel} breakPoints={breakPoints}>
                {productType === 'categories'?
                  categories?.map((item, i) => (
                    <ServiceCard key={i} service={item} {...{displayDescription,productType,companyId}} />
                  ))
                :
                  services?.map((item, i) => (
                    <ServiceCard key={i} service={item} {...{displayDescription,companyId}} />
                  ))
                }
              </Carousel>
            </Box>
          ) : (
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              {productType === 'categories'?
                categories?.map((item, i) => (
                  <ServiceCard key={i} service={item} {...{displayDescription,productType,companyId}} />
                ))
              :
                services?.map((item, i) => (
                  <ServiceCard key={i} service={item} {...{displayDescription,companyId}} />
                ))
              }
            </Box>
          )}
        </Box>
      </Box>
    );
  }

  return null;
};

export default ServiceDetails;
